import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import {
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  ToolbarModule,
  TableModule,
} from 'beyond-util';
import { PopustiUvecanjaComponent } from './popusti-uvecanja.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
  ],
  declarations: [PopustiUvecanjaComponent],
  entryComponents: [PopustiUvecanjaComponent],
  exports: [PopustiUvecanjaComponent],
})
export class PopustiUvecanjaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/popusti-uvecanja/popusti-uvecanja.module.ts